export default __webpack_public_path__ + "static/media/next.29ca8ed0.svg";